import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import Fade from "react-reveal/Fade";

const LeetCodeIcon = () => (
  <svg
    className="media-icons"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill="currentColor"
      d="M13.5 3.5 16 6l-6.2 6.2L16 18.4l-2.5 2.5L5.3 12.7 13.5 3.5zm4.2 4.2h2.8v8.6h-2.8V7.7z"
    />
  </svg>
);

const Cover = () => {
  return (
    <div className="bg-div" id="home">
      <div className="hero-wash" aria-hidden="true" />
      <div className="head mx-5">
        <div className="head-div mx-auto main-div">
          <Fade top cascade>
            <section className="div-1">
              <h1 className="my-1 head-div-first-text">Hi, my name is</h1>
              <h1 className="head-div-second-text">Deepak Singh.</h1>
              <h1 className="head-div-third-text">
                Backend, full-stack, and GenAI.
              </h1>
              <div className="hero-chips">
                <span>Senior Software Engineer</span>
                <span>Pune, India</span>
              </div>
              <p className="head-div-fourth-text">
                I build backend systems and full-stack products with Node.js,
                NestJS, TypeScript, and React. Recent work covers microservices,
                API performance, multi-tenant design, and a RAG platform on
                Azure and AWS.
              </p>
            </section>
          </Fade>
        </div>
      </div>
      <Fade bottom>
        <span className="scroll-btn">
          <a href="#about" aria-label="Scroll to about">
            <span className="mouse">
              <span></span>
            </span>
          </a>
        </span>
      </Fade>
      <div className="social-media">
        <Fade left cascade>
          <ul className="social-media-list">
            {SocialData.map((data, ind) => {
              return (
                <li key={ind}>
                  <a
                    className="social-media-list-link"
                    href={data.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={data.label}
                  >
                    {data.icon === "leetcode" ? (
                      <LeetCodeIcon />
                    ) : (
                      <FontAwesomeIcon
                        icon={data.icon}
                        className="media-icons"
                      />
                    )}
                  </a>
                </li>
              );
            })}
          </ul>
        </Fade>
      </div>
    </div>
  );
};

export default Cover;

const SocialData = [
  {
    link: "https://github.com/dp789",
    icon: faGithub,
    label: "GitHub",
  },
  {
    link: "https://www.linkedin.com/in/dp2707",
    icon: faLinkedin,
    label: "LinkedIn",
  },
  {
    link: "https://leetcode.com/u/Dp_pk",
    icon: "leetcode",
    label: "LeetCode",
  },
];
